import { AxiosError } from "axios";

import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import adminAxios from "@/lib/axios";

export interface IComparison {
  id?: number | string;
  page_id?: number;
  component_id?: number;
  desktop_background_color?: string;
  mobile_background_color?: string;
  backvariant?: string;
  gradient_color_1?: string;
  gradient_color_2?: string;
  gradient_color_3?: string;
  gradient_color_4?: string;
  pre_title?: string;
  pre_title_color?: string;
  title?: string;
  title_start_color?: string;
  title_end_color?: string;
  title_gradient_angle?: string;
  description?: string;
  description_text_color?: string;
  column1?: string;
  column1_text_color?: string;
  column1_background_color?: string;
  column2?: string;
  column2_text_color?: string;
  column2_background_color?: string;
  column3?: string;
  column3_text_color?: string;
  column3_background_color?: string;
  cta_text?: string;
  cta_text_color?: string;
  cta_background_color?: string;
  variant?: string;
  metadata?: any[];
  status?: boolean;
}

export async function createComparison(payload: Partial<IComparison>) {
  try {
    const response = await adminAxios.post(
      ADMIN_API_ENDPOINTS.COMPARISON.CREATE,
      payload
    );

    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function updateComparison(id: number, payload: Partial<IComparison>) {
  try {
    const response = await adminAxios.put(
      ADMIN_API_ENDPOINTS.COMPARISON.UPDATE(id),
      payload
    );

    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}
